import * as React from "react";
import { useRecordContext } from "react-admin";
import {
    Button, Tooltip, Dialog, DialogTitle, DialogContent,
    DialogActions, TextField
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import BlockIcon from "@mui/icons-material/Block";
import { adminPatch } from "../../config/api";
import useModerationAction from "../../hooks/useModerationAction";

export default function RejectOobjectButton() {
    const record = useRecordContext();
    const { loading, run } = useModerationAction();
    const [open, setOpen] = React.useState(false);
    const [reason, setReason] = React.useState("");

    if (!record || record.status === "REJECTED") return null;

    const submit = async () => {
        await run({
            id: record.id,
            missingIdMessage: "ID oobject manquant.",
            request: () => adminPatch(`/oobjects/${record.id}/reject`, { reason: reason || null }),
            successMessage: "Oobject rejeté",
            onSuccess: () => {
                setOpen(false);
                setReason("");
            },
        });
    };

    return (
        <>
            <Tooltip title="Rejeter cet oobject">
        <span>
          <Button
              onClick={(event) => {
                  event?.stopPropagation?.();
                  setOpen(true);
              }}
              disabled={loading}
              variant="contained"
              sx={{
                  bgcolor: "#d32f2f",
                  color: "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  px: 2,
                  py: 0.5,
                  fontWeight: "bold",
                  ml: 1,
                  "&:hover": { bgcolor: "#b71c1c" },
              }}
              startIcon={
                  loading ? <CircularProgress size={16} sx={{ color: "white" }} /> : <BlockIcon />
              }
          >
            Rejeter
          </Button>
        </span>
            </Tooltip>

            <Dialog open={open} onClose={() => !loading && setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Confirmer le rejet</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Motif (optionnel)"
                        fullWidth
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={loading}>Annuler</Button>
                    <Button
                        onClick={submit}
                        disabled={loading}
                        variant="contained"
                        sx={{ bgcolor: "#d32f2f", "&:hover": { bgcolor: "#b71c1c" } }}
                    >
                        {loading ? <CircularProgress size={16} sx={{ color: "white" }} /> : "Confirmer le rejet"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
